import { demoFile, feature } from 'system/demo';
import { SimpleCommentsStructure } from 'structure/simple-comments';

demoFile('feature/ranking/ai-quality-ranking');

const collections = {
    comment: [
        {key: '1', from: 'a', text: 'Great idea!'},
        {key: '2', from: 'b', text: 'Needs work'}
    ],
    comment_quality: [
        {key: '1', helpful: 1, civil: 1},
        {key: '2', helpful: 0, civil: 1}
    ],
    comment_bridging: [
        {key: '1', bridging: 1},
        {key: '2', bridging: 0}
    ]
};

feature('ai-quality-ranking', {
    structureKey: 'simplecomments',
    config: SimpleCommentsStructure.defaultConfig,
    features: {
        'show-ranking-features': true
    },
    state: {
        collections,
        sessionData: {roles: ['Owner']}
    }
});
